import React from 'react';
import { ICartOption, ItemCounterTypes } from '../../../../../../../Interfaces/componentTypes';
import styles from './itemCounter.module.scss';

interface IProps {
  count?: number;
  option: ICartOption;
  type: ItemCounterTypes;
  handleAddOption: (option: ICartOption, count: number) => void
}

const ItemCounter: React.FC<IProps> = (props) => {
  const { count, option, type, handleAddOption } = props;
  return (
    <div className={type === ItemCounterTypes.CART ? styles.container : styles.box}>
      <div
        className={
          type === ItemCounterTypes.CART
            ?
            (+count! > 0 ? styles.button : styles.disableButton)
            :
            styles.icon
        }
        onClick={+count! > 1 ? () => handleAddOption(option, -1) : undefined}>
        <p>-</p>
      </div>
      <div className={styles.count}>
        <p>
          {count ?? '0'}
        </p>
      </div>
      <div className={type === ItemCounterTypes.CART ? styles.button : styles.icon}
        onClick={() => handleAddOption(option, 1)}>
        <p>+</p>
      </div>
    </div>
  )
}

export default ItemCounter
